import React from "react";
import PropTypes from "prop-types";
import { lockShape } from "data/lockStore";

function LockMessage({label = "this record", lock}) {
    if (lock && (lock.violated && !lock.dismissed)) {
        return (
            <div
                className="alert alert-info pesslock-status pesslock-warning"
            >
                <i className="glyphicon glyphicon-exclamation-sign" />
                {" "}
                {lock.violators.join(", ")}
                {" "}
                also {lock.violators.length === 1 ? "has" : "have"} {label} open.
            </div>
        );
    }
    return null;
}

LockMessage.propTypes = {
    lock: PropTypes.shape(lockShape),
    label: PropTypes.element,
};

export default LockMessage;



// WEBPACK FOOTER //
// ./app/lib/lock/LockMessage.js